import { render, staticRenderFns } from "./AddOptionalDoctors.vue?vue&type=template&id=3b168f5e"
import script from "./AddOptionalDoctors.vue?vue&type=script&lang=js"
export * from "./AddOptionalDoctors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports